import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { store } from '../store/index'

import Button from './Button'

import uploadIcon from 'assets/images/upload.svg'
import closeBtn from 'assets/images/close.svg'
import { CONFIG_BASE_URL } from '../utils/consts'

const UploadArea = ({
  photoList = [],
  changeUploadPhoto,
  changeDeletedPhoto,
}) => {
  const [myFiles, setMyFiles] = useState(photoList)
  const [deletedFiles, setDeletedFiles] = useState([])
  const { access } = store.getState().tokenInfo

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: 'image/jpeg',
    multiple: false,
    onDrop: acceptedFiles => {
      changeUploadPhoto(acceptedFiles[0])
      setMyFiles([
        ...myFiles,
        ...acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ])
    },
  })

  const thumbs = myFiles.map(file => (
    <div
      className='upload-file'
      key={file.name || file.id}
      style={{
        background: `url(${
          file.preview ||
          CONFIG_BASE_URL + file.url_path + '?token=' + access
        }) no-repeat 50% 50% / cover`,
      }}>
      <Button
        className='btn--icon'
        icon={true}
        iconPicture={closeBtn}
        action={() => removeFile(file)}
      />
    </div>
  ))

  /**
   * @param {Object} file
   */
  const removeFile = file => {
    const files = [...myFiles]
    files.splice(files.indexOf(file), 1)
    setMyFiles(files)

    if (file.id) {
      const files = [...deletedFiles]
      files.push(file.id)
      setDeletedFiles(files)
      changeDeletedPhoto(files)
    }
  }

  useEffect(
    () => () => {
      myFiles.forEach(file => URL.revokeObjectURL(file.preview))
    },
    [myFiles]
  )

  return (
    <div className='container-upload'>
      <div
        {...getRootProps({
          className: !myFiles.length
            ? 'container-upload__area'
            : 'container-upload__area container-upload__area--hidden',
        })}>
        <div className='upload-area-wrapper'>
          <input {...getInputProps()} />
          <div>
            <img src={uploadIcon} alt='' />
            <p>Нажмите на эту область для добавления фото</p>
          </div>
        </div>
      </div>

      {!!myFiles.length && (
        <>
          <div className='container-upload__files'>{thumbs}</div>
          <Button className='btn--link' title='Добавить фото' action={open} />
        </>
      )}
    </div>
  )
}

export default UploadArea
